// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeOffRequest_root__1pApQ","member":"TimeOffRequest_member__1PzMh","avatar":"TimeOffRequest_avatar__3YLrc","comment":"TimeOffRequest_comment__3CSBy"};